<app-time-entries-sum-view
    [label]="'Gesamt'"
    [ownerId]="order?.id">
</app-time-entries-sum-view>
<app-time-entry-categories-sum-view [ownerId]="order?.id"></app-time-entry-categories-sum-view>

<app-order-operated-rental-task-list-protocol-view
    [orderId]="order?.id">
</app-order-operated-rental-task-list-protocol-view>
